import { default as calculationzxZCEJq5hmMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detail9vW7TuilhOMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryxVsk43qAyUMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93RBZjrvob95Meta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listycMJjz36NVMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingAh8gBD7TESMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyoumKWYaPUtOoMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellGR47GUwNpqMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadost0tDXwbQ1ZGMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankySipy1b0IbMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnani8w0tzJxTFSMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pageZMZNcCRyEGMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testHS9OvJrjxvMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepagextvszwUYtxMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleWldKYvTDHSMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternshyOfZVhru5Meta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagapwfBlv3OxMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorIXIjzLF9xYMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categorydafTBQip54Meta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectioniToIeafH8wMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesWThhgk1Bc4Meta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryy3bFNNSChSMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleLwH73lvEheMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as section4m8Q5S4VLCMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactcDPtDMkdJmMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45termination4u7s5CJsHMMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationik0uaxScu3Meta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youltuAAwU6fMMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detail1sDybEZ6C9Meta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquirytWQ5VVReaOMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listEb6ovIFnvBMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationRJuRMZ2LuOMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youx9w4pWxOclMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryvqCcrqjWuKMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45list0ExOiLsmfNMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailm1TCRcxk3TMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offer5dLiQxgvFHMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiry9IeiJsqLHkMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youLcvqWAKiaaMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationlsrb1I9nIaMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listfBd2tPq5p0Meta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youa4dZHkxjJJMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineVWvYtxoINfMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailydvCI5xCYvMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneTqYoAE920GMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerY53VwCu6GdMeta } from "/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani-ab/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadost0tDXwbQ1ZGMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankySipy1b0IbMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnani8w0tzJxTFSMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pageZMZNcCRyEGMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testHS9OvJrjxvMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepagextvszwUYtxMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleWldKYvTDHSMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternshyOfZVhru5Meta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagapwfBlv3OxMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorIXIjzLF9xYMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categorydafTBQip54Meta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectioniToIeafH8wMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesWThhgk1Bc4Meta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageZMZNcCRyEGMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryy3bFNNSChSMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleLwH73lvEheMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: section4m8Q5S4VLCMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: section4m8Q5S4VLCMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactcDPtDMkdJmMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45termination4u7s5CJsHMMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationik0uaxScu3Meta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youltuAAwU6fMMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detail1sDybEZ6C9Meta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquirytWQ5VVReaOMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listEb6ovIFnvBMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationRJuRMZ2LuOMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youx9w4pWxOclMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryvqCcrqjWuKMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45list0ExOiLsmfNMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailm1TCRcxk3TMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offer5dLiQxgvFHMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiry9IeiJsqLHkMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youLcvqWAKiaaMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationlsrb1I9nIaMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listfBd2tPq5p0Meta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youa4dZHkxjJJMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineVWvYtxoINfMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailydvCI5xCYvMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneTqYoAE920GMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerY53VwCu6GdMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src1183957408/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]